/* eslint-disable no-alert, no-case-declarations */
import * as types from "actions/actionTypes/offer/partnerRelations/index";
import { DOCUMENT_PARTNER_RELATIONS_INVALIDATED } from "actions/eventTypes/offer/partnerRelations/index";
import initialState from "../../initialState";

export default function partnerRelationsReducer(state = initialState.currentOffer.documentPartnerRelations, action) {
  switch (action.type) {
    case types.LOAD_DOCUMENT_PARTNER_RELATIONS_SUCCEEDED:
      const { documentPartnerRelations } = action.payload;

      return {
        ...state,
        documentPartnerRelations,
        isLoaded: true
      };

    case types.LOAD_PARTNER_RELATION_TYPES_SUCCEEDED:
      const { partnerRelationTypes } = action.payload;

      return {
        ...state,
        partnerRelationTypes,
        partnerRelationTypesIsLoaded: true
      };

    case DOCUMENT_PARTNER_RELATIONS_INVALIDATED:
      return {
        ...state,
        documentPartnerRelations: [],
        isLoaded: false
      };

    default:
      return state;
  }
}
